













































import GalleryItem from '@/components/GalleryItem'

export default {
    name: 'Gallery'

    components:
        GalleryItem: GalleryItem

    data: -> 
        filterTags: []
        fields: @defaultFields()

    computed:
        isDark: -> @$parent.isDark
        isScreenWidth: -> @fields.width is 'Bildschirm'
        isPageWidth: -> @fields.width is 'Seite'
        isTextWidth: -> @fields.width is 'Text'
        isSlider: -> @fields.slide_function is 'eingeschaltet'
        hasFilter: ->  
            @filterTags.length > 0 and !@isSlider
        
        containerClass: ->
            'uk-container': @isPageWidth
            'uk-container uk-container-small': @isTextWidth
        
        imageHeight: ->
            if @fields.image_height is 'standard' then '65%' else @fields.image_height
        
    methods:
        updateSlider: ->
            if @$refs.slider then UIkit.slider(@$refs.slider).$emit(event = 'update');

        defaultFields: ->
            image_height: 'standard'
            width: 'Bildschirm'
            slide_function: 'ausgeschaltet'
            items: []

        setContent: (document) ->
            fields = 
                image_height: document.primary.image_height
                width: document.primary.width
                slide_function: document.primary.slide_function
                items: document.items
            $.extend @fields, fields

    mounted: ->
        if @hasFilter then UIkit.filter @$el, target: '.js-filter'

    created: ->
        @setContent @$attrs.document
}
